import Vue from 'vue';
import Clipboard from 'v-clipboard';
import { Bridger } from '@estrategiahq/frontend-libs/bridger';

import { $emit, $on, $off } from '@/utils/bus';
import { aclPlugin } from '@/utils/acl';
import { envPlugin } from '@/utils/env';
import { CToast } from '@estrategiahq/coruja-web-ui';
import App from './App';
import router from './router';
import store from './store';
import services from './services';
import global from './utils/global';
import { createProvider } from './apollo';
import users from './users';
import 'animate.css';
import './quasar';
import './assets/global.css';

Vue.config.productionTip = false;
Vue.use(envPlugin);
Vue.use(aclPlugin, {
  users,
});

Vue.use(Clipboard);
Vue.use(CToast);

Object.defineProperty(Vue.prototype, '$g', {
  get: () => global,
  set() {
    throw new Error('You can\'t set $g');
  },
});

Object.defineProperty(Vue.prototype, '$bus', {
  get: () => ({ $emit, $on, $off }),
  set() {
    throw new Error('You can\'t set $bus');
  },
});

Object.defineProperty(Vue.prototype, '$services', {
  get: () => services,
  set() {
    throw new Error('You can\'t set $services');
  },
});

const bridger = Bridger().Consumer();
Object.defineProperty(Vue.prototype, '$bridger', {
  get: () => bridger,
  set() {
    throw new Error('You can\'t set $bridger');
  },
});

router.afterEach((to) => {
  Bridger().Consumer().$dispatch({
    type: 'router_navigation:after',
    payload: {
      fullPath: to.fullPath,
      query: to.query,
    },
  });
});
const app = new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
});
const startApp = () => app.$mount('#app');

const setupBridgerEvents = () => {
  let started = false;
  const maybeStartApp = () => {
    if (localStorage.getItem('token') && sessionStorage.getItem('vertical') && !started) {
      started = true;
      startApp();
    }
  };

  bridger.$subscribe('event:user-login', (payload) => {
    localStorage.setItem('user', payload.email);
    localStorage.setItem('token', payload.token);
    localStorage.setItem('acl', JSON.stringify(payload.acl));
    localStorage.setItem('permissions', JSON.stringify(Object.values(payload.permissions)));
    maybeStartApp();
  });

  bridger.$subscribe('event:vertical-change', (payload) => {
    started = false;

    if (payload !== sessionStorage.getItem('vertical')) {
      app.$forceUpdate();
      sessionStorage.setItem('vertical', payload);
      maybeStartApp();
      window.location.reload();
    }
  });
};

if (window.self !== window.top) { // iframed
  setupBridgerEvents();
} else if (localStorage.getItem('token')) { // standalone, but has token
  startApp();
}
